// HQ-2344: параметры слоя страницы клуба и игроков страны в поиске адреса мира. Отдельно от worldDetail.tsx: App.tsx
// читает их в главном чанке, а сами экраны слоя живут в чанке мира.
export const DETAIL_CLUB = 'club';
export const DETAIL_FANS = 'fans';
export const FANS_NAME = 'fans_name';
export const FANS_FLAG = 'fans_flag';
export const DETAIL_KEYS = [DETAIL_CLUB, DETAIL_FANS, FANS_NAME, FANS_FLAG];

/** Открыт ли слой по поиску адреса (App: «Назад» снимает слой, а не выходит из мира). */
export function hasWorldDetail(search: string): boolean {
  const s = new URLSearchParams(search);
  return s.has(DETAIL_CLUB) || s.has(DETAIL_FANS);
}

/** Поиск адреса с открытым слоем: прежние параметры экрана (path, top, hub…) как есть, параметры слоя — новые.
 *  Слой уже открыт (клуб из клуба) — replace: «Назад» ведёт к экрану под слоем, а не к прошлому слою. */
export function detailSearch(current: string, params: Record<string, string | null | undefined>): { search: string; replace: boolean } {
  const s = new URLSearchParams(current);
  const replace = DETAIL_KEYS.some((k) => s.has(k));
  DETAIL_KEYS.forEach((k) => s.delete(k));
  Object.entries(params).forEach(([k, v]) => { if (v) s.set(k, v); });
  return { search: `?${s.toString()}`, replace };
}
